import * as angular from 'angular';
import { PhoneNumberUtil } from 'google-libphonenumber';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.$profile = this.profileFromDto();
        this.profile = this.profileFromDto();
        this.PNU = PhoneNumberUtil.getInstance();
    }

    save() {
        this.isSaving = true;
        this.AccountsResource
            .updateProfileAttributes(this.companyId, this.accountId, this.profile)
            .then((profile) => {
                Object.assign(this.profileAttributes.profile, profile);
                this.$state.go('^',{},{reload:'company.user-directories.manage-account'});
                this.Alert('success', 'company.user-directories.manage-account.profile-attributes.edit.saved');
            })
            .finally(() => this.isSaving = false)
    }

    profileFromDto() {
        const profile = this.profileAttributes.profile;
        return {
            id: profile.id,
            firstName: profile.firstName || '',
            lastName: profile.lastName || '',
            email: profile.email || '',
            phoneNumber: profile.phoneNumber || '',
            city: profile.city || '',
            streetAddress: profile.streetAddress || '',
            country: profile.country || '',
            department: profile.department || '',
            jobTitle: profile.jobTitle || '',
            companyName: profile.companyName || '',
            zipCode: profile.zipCode || '',
        };
    }

    notModified() {
        return angular.equals(this.$profile, this.profile);
    }

    saveDisabled(form) {
        return form.$invalid || this.invalidPhoneNumber || this.isSaving || this.notModified();
    }

    validatePhoneNumber() {
        this.invalidPhoneNumber = !!this.profile.phoneNumber && (
            !this.PNU.isPossibleNumberString(this.profile.phoneNumber)
            || !this.PNU.isValidNumber(this.PNU.parse(this.profile.phoneNumber))
        )
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/profile-attributes/edit/edit-profile-attributes.controller.js